<template>
  <div class="whole">
    <h3>版本更新内容</h3>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.17</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-05-16</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.取消网站权限限制 </p>    
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.16</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-03-29</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.消息订阅：添加消息订阅地址填写提示、添加重复订阅验证 </p>    
        
      </div>
    </section>
    <hr>

    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.15</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-03-22</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.稳定币：BUSD大额交易隐藏 </p>
        <p >2.工单系统支付页面重新排版更新页面</p>
        <p >3.BTC-网络-大额交易搜索框位置调整，搜索条件输入优化</p>   
        <p >4.检查所有页面英文状态下的显示优化</p>   
        <p >5.所有滚动条页面两侧显示时间，1天的数据不显示时分秒</p>   
      </div>
    </section>
    <hr>
    
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.14</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-03-13</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.检查所有页面图表优化显示调整保留小数：11个页面：<br>a.短持者未实现的净收益损失比：改为保留4为小数<br>b.按余额划分 地址数分布  余额 >=100 & < 1000 比率分布：改为保留4为小数<br>c.按余额划分 币数量分布 8个页面比率分布：改为保留4为小数<br>d.市场指标：Arh999囤币及逃顶指标 24小时数据图：改为保留4为小数 </p>
        <p >2.redmine需求: <br>a.未登录用户进入网站后不要直接弹登陆页面 <br>b.未登录用户保持现有权限不变 <br>c.未登录用户权限以外的页面，遮罩层应该跳转到登陆页面，而非升级页面  <br> d.登陆页面的注册按钮应该显示更明显 <br> e.导航栏 个人中心 应改为当前账号名称，下拉菜单中的账号名称应该为个人中心，只改显示名称，不改跳转和功能</p>
        <p >3.优化登录成功 当前页面刷新</p>   
        <p >4.优化柱状图可以显示全部：买入大单挂单、卖出大单挂单</p>   
      

       
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.13</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-03-07</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.大额交易页面变更需求：<br>(1).表格--利润：计算方式更改（数值-1）/100保留6位小数改为 数值*100 保留5位小数<br>(2).receive n表头改为 该笔交易索引号   vout.n</p>
        <p >2.每日已实现盈利交易占比实时数据变更需求 <br>变更前：直接用返回数值添加% 变更后：数值需要乘以100后添加百分号</p>
        <p >3.已花费输出休眠平均天数(供应量调整)：调整保留小数位数为8位，返回的科学计算法数据重新处理 </p>
        <p >4.BTC持有者分布-按余额划分币数量分布：所有页面的tooltip 显示添加 “/ Total”</p>
        <p >5.新用户注册通知已添加</p>
        <p >6.检查所有页面，数据按天返回的修改渲染方式，去掉tooltip时分秒</p>
        <p >7. 统一所有页面，统一设置调整Y轴 （左侧Y轴数据，右侧Y轴价格）：稳定币、宏观经济</p>
        <p >8. 页面bug修复</p>

       
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.12</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-03-01</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.修改版本号V2.1.2 改为V2.0.12</p>
        <p >2.页面中英文导航根据拆分图例页面的excel对应修改 </p>
        <p >3.coinbus路由调整：（1）根据结构图修改导航栏及相关路由对应页面调整 （2）导航栏权限更新修改（目前没有客服权限、暂时设置admin权限） （3）转账记录、提现记录、充值、提现订单页面删除 </p>
        <p >4.消息订阅：订阅与告警已完成与后端联调，还需验证中英文传参是否有问题  </p>

       
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.1.2</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-02-20</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.BTC币种所有页面，统一设置调整Y轴 （左侧Y轴数据，右侧Y轴价格）</p>
        <p style="line-height: 30px;">2.页面拆分：
          <br> 按余额划分-地址数分布拆分为：余额 <=0.01、余额 >=0.01 & < 0.1、余额 >=0.1 & < 1、余额 >=1 & < 10、余额 >=10 & < 100、余额 >=100 & < 1000、余额 >=1000 & < 10000、余额 >=10000
          <br> 按余额划分-币数量分布拆分为拆分为：余额 <=0.01、余额 >=0.01 & < 0.1、余额 >=0.1 & < 1、余额 >=1 & < 10、余额 >=10 & < 100、余额 >=100 & < 1000、余额 >=1000 & < 10000、余额 >=10000
        </p>
       
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.1.1</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-02-20</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p style="line-height: 30px;">1.页面拆分：<br> 待交易池详情拆分为：交易内存池数量、交易内存池费用 <br> 币天销毁量拆分为：币天销毁量、币天销毁量(供应调整)<br>
          已花费输出休眠平均天数拆分为：已花费输出休眠平均天数、已花费输出休眠平均天数(供应量调整)
          <br>
          合约主动买入量拆分为：合约主动买入量、合约主动买入量(买卖比率)
        </p>
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.1.0</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-02-06</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.未平仓合约数、合约主动买入量默认请求开始时间为当前日期减去一个月</p>
        <p>2.页面拆分：交易统计拆分为：交易量、交易费、交易量(找零消除) <br> 地址统计拆分为：地址统计、新地址数、新地址交易量、总地址数<br>矿工余额拆分为：矿工地址数、矿工地址余额</p>
        
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.9</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-02-02</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.币天销毁量年龄分布处理价格后面百分号问题</p>
        <p>2.每日已实现盈利交易占比 实时数据显示问题（价格返回数据问题已反馈）</p>
        <p>3.宏观经济-货币金融-实时汇率页面，美元固定在第一行</p>
        <p>4.交易所余额上方，将all固定在第一个</p>
        <p>5.持有者分布-按持有时间划分页面24h变化未体现出来(已取消24H按钮)</p>
        <p>6.资金费率增加图例，可以选择曲线或者柱状图</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.8</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-01-29</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.地址统计实时数据隐藏ew_address、total_address、new_address_volume数据为0</p>
        <p>2.隐藏ETH币种所有页面</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.7</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-01-26</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.BTC以下页面添加实时数据:地址统计 、交易统计、已花费输出盈利比、已花费输出平均寿命、已花费输出休眠平均天数、币天销毁量、币天销毁量年龄分布、每日已实现盈利交易占比</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.6</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-01-23</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.隐藏未实现功能的静态页面</p>
        <p>2.优化404页面</p>       
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.5</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-01-19</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.个人资料页面取消权限等级情况的标签页</p>
        <p>2.单独新增权限等级页面</p>
        <p>3.订阅与告警新增阈值类型选择（范围输入、数值输入）</p>
        <p>4.后台管理--访问统计页面（数据监控）删除</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.4</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2024-1-11</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.BTC、ETH交易所余额修改渲染方式(无数据不补0)</p>
        <p>2.消息订阅页面添加</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.3</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2023-12-21</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.页面数据长短不一致弹窗显示权限控制,只能admin权限用户显示</p>
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.2</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2023-12-8</span>
      </div>
      <div>
        <span>更新内容：</span>
        <p>1.成交量分布图页面隐藏</p>
        <p>2.宏观经济--国债收益率页面显示图表滚动条、优化页面添加拖拽提示</p>    
      </div>
    </section>
    <hr>
    <section class="single">
      <div>
        <span>版本号：</span>
        <span>V2.0.1</span>
      </div>
      <div>
        <span>更新日期：</span>
        <span>2023-11-22</span>
      </div>
      <div>
        <span>更新内容：</span>
        <span>增加更新内容页面</span>
      </div>
    </section>
    
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.whole{
  padding: 0px 20px;
}
.single{
    padding-left: 20px;
    margin-top: 30px;
    div{
        margin-top: 10px;
        // outline: 1px solid #ccc;
    }
}
</style>